export const version = "units/5.2.0";
//# sourceMappingURL=_version.js.map